import { useSelector } from "react-redux";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useTranslation } from "react-i18next";
import CIPPaginatedTable from "../CIPPaginatedTable";
import { CIP_SOURCE_OPTIONS } from "../../constants/global.constants";

const UserAddedCIP = () => {
  const { t, i18n } = useTranslation();
  const selectedTrain = useSelector((state) => state.selTrain);

  return (
    <div>
      <div
        className="lightGrayBorder"
        style={{ padding: "16px", marginTop: "10px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="headerTealText">{t("CIPShutdownStrings.title")}</div>
        </div>
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", marginTop: "10px", overflow: "auto" }}
        >
          <CIPPaginatedTable
            selectedTrain={selectedTrain}
            source={CIP_SOURCE_OPTIONS.USER}
            // Export As CSV functionality is on hold
            // exportFileName={t("excelSheetNames.cipAndShutdown")}
            enableActions
            enableAdd
          />
        </div>
      </div>
    </div>
  );
};

export default UserAddedCIP;
